import { render } from "./AppLayout.vue?vue&type=template&id=47352ab0"
import script from "./AppLayout.vue?vue&type=script&lang=js"
export * from "./AppLayout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/crynobone/Projects/laravel/nova/aries/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"AppLayout.vue"]])

export default __exports__